<template>
  <div :class="$style.analytics">
    <div :class="$style.tableContent">
      <Header />
      <AnalyticsHeader
        :organization="params.organization"
        :isFilterActive="isFilterActive"
        :unverifiedCount="unverifiedCount"
        @openFilter="openFilter"
        @clearFilter="clearFilter"
        @deleteNotVerified="deleteNotVerified"
      />
      <div :class="$style.container">
        <SupervisionTable
          :supervisions="supervisions"
          :supervision="supervision"
          @open="open"
          @setVerified="setVerified"
          @setVerifiedItem="setVerifiedItem"
          @openModal="openModal"
          @openImage="openImage"
        />
      </div>
    </div>
    <SupervisionSidebar
      :isOpen="isMenuOpen"
      :supervision="supervision"
      @close="isMenuOpen = false"
      @saveAdminComment="saveAdminComment"
    />
    <EditActivityModal
      :isOpen="isModalOpen"
      :activity="activity"
      :supervisionId="supervision?.id"
      @close="isModalOpen = false"
      @saved="onActivitySaved"
    />
    <ImageModal
      :isOpen="isImageModalOpen"
      :comment="comment"
      :image="image"
      @close="isImageModalOpen = false"
    />
  </div>
  <FilterModal
    v-if="iconsModals.filter"
    :params="params"
    @setFilter="
      ({ organization, worker, user, search, date, verified }) =>
        setFilter(organization, worker, user, search, date, verified)
    "
  />
</template>

<script>
import { mapState } from "vuex";
import Repository from "@/repository";
import Header from "@/components/common/Header.vue";
import FilterModal from "@/components/analytics/FilterModal.vue";
import AnalyticsHeader from "@/components/analytics/AnalyticsHeader.vue";
import SupervisionTable from "@/components/analytics/SupervisionTable.vue";
import SupervisionSidebar from "@/components/analytics/SupervisionSidebar.vue";
import EditActivityModal from "@/components/analytics/EditActivityModal.vue";
import ImageModal from "@/components/analytics/ImageModal.vue";

export default {
  components: {
    Header,
    FilterModal,
    AnalyticsHeader,
    SupervisionTable,
    SupervisionSidebar,
    EditActivityModal,
    ImageModal,
  },
  data() {
    return {
      supervisions: [],
      supervision: {},
      isMenuOpen: false,
      isModalOpen: false,
      isImageModalOpen: false,
      activity: {},
      comment: {},
      image: "",

      params: {
        organization: "",
        worker: "",
        user: "",
        search: "",
        date: "",
        verified: false,
      },
    };
  },
  async mounted() {
    await this.featchData();
    this.openFilter();
  },
  methods: {
    async featchData() {
      this.$store.commit("setLoadersCount", "+");
      const params = {};

      if (this.params.search) {
        params.id = this.params.search;
      } else {
        if (this.params.date) {
          if (this.params.date.start) {
            params.start_date = this.params.date.start;
          }
          if (this.params.date.end) {
            params.end_date = this.params.date.end;
          }
        }
        if (this.params.worker) {
          params.worker = this.params.worker;
        }
        if (this.params.user) {
          params.user = this.params.user;
        }
        if (this.params.organization) {
          params.organization = this.params.organization;
        }
        if (
          this.params.verified !== null &&
          this.params.verified !== undefined
        ) {
          params.verified = this.params.verified;
        }
      }

      const { value, error } = await Repository.Supervision.get(params);
      console.log(value);
      this.$store.commit("setLoadersCount", "-");
      if (value) {
        this.supervisions = value.results;
      }
    },
    async open(item) {
      // const { value, error } = await Repository.Supervision.Analytics.get({
      //   id: item.id,
      // });
      // if (value) {
      //   if (item.isOpen) {
      //     item.isOpen = false;
      //     this.isMenuOpen = false;
      //   } else {
      //     this.supervisions.forEach((i) => (i.isOpen = false));
      //     item.isOpen = true;
      //     this.isMenuOpen = true;
      //   }
      //   this.supervision = value;
      // }
      if (item.isOpen) {
        item.isOpen = false;
        this.isMenuOpen = false;
      } else {
        this.supervision = item;
        this.supervisions.forEach((i) => (i.isOpen = false));
        item.isOpen = true;
        this.isMenuOpen = true;
      }
    },
    openFilter() {
      this.$store.commit("setIconsModals", {
        modal: "filter",
        value: true,
      });
    },
    async setFilter(organization, worker, user, search, date, verified) {
      this.params.organization = organization;
      this.params.worker = worker;
      this.params.user = user;
      this.params.search = search;
      this.params.date = date;
      this.params.verified = verified;
      await this.featchData();
    },
    async clearFilter() {
      this.params.organization = "";
      this.params.worker = "";
      this.params.user = "";
      this.params.search = "";
      this.params.date = "";
      this.params.verified = false;
      await this.featchData();
    },
    openModal(activity) {
      this.activity = activity;
      this.isModalOpen = true;
    },
    openImage(comment, image) {
      this.comment = comment;
      this.image = image;
      this.isImageModalOpen = true;
    },
    async setVerified(item) {
      this.$store.commit("setLoadersCount", "+");
      let result = true;
      if (item.verified) {
        const { value, error } = await Repository.Supervision.resetVerified({
          id: item.id,
        });
        result = value;
      } else {
        const { value, error } = await Repository.Supervision.setVerified({
          id: item.id,
        });
        result = value;
      }
      this.$store.commit("setLoadersCount", "-");
      if (result) {
        item.verified = !item.verified;
      }
    },
    async setVerifiedItem(item) {
      this.$store.commit("setLoadersCount", "+");
      let result = true;
      if (item.verified) {
        const { value, error } =
          await Repository.Supervision.Analytics.resetVerified({
            id: item.id,
          });
        result = value;
      } else {
        const { value, error } =
          await Repository.Supervision.Analytics.setVerified({
            id: item.id,
          });
        result = value;
      }
      this.$store.commit("setLoadersCount", "-");
      if (result) {
        item.verified = !item.verified;
      }
    },
    async saveAdminComment({ id, admin_comment }) {
      const supervisionItem =
        this.supervision.id === id
          ? this.supervision
          : this.supervisions.find((s) => s.id === id);

      if (!supervisionItem || !supervisionItem.organization) {
        return;
      }

      const organization =
        supervisionItem.organization?.id || supervisionItem.organization;

      this.$store.commit("setLoadersCount", "+");
      const { value, error } = await Repository.Supervision.updateAdminComment({
        id,
        admin_comment,
        organization,
      });
      this.$store.commit("setLoadersCount", "-");
      if (value) {
        // Обновляем данные в supervision
        if (this.supervision.id === id) {
          this.supervision.admin_comment = admin_comment;
        }
        // Обновляем данные в списке supervisions
        const item = this.supervisions.find((s) => s.id === id);
        if (item) {
          item.admin_comment = admin_comment;
        }
      }
    },
    onActivitySaved(updatedActivity) {
      // Обновляем активность в supervision.analytics
      if (
        this.supervision?.analytics &&
        Array.isArray(this.supervision.analytics)
      ) {
        const index = this.supervision.analytics.findIndex(
          (a) => a.id === updatedActivity.id
        );
        if (index !== -1) {
          // В Vue 3 создаем новый массив для гарантии реактивности
          this.supervision.analytics = [
            ...this.supervision.analytics.slice(0, index),
            updatedActivity,
            ...this.supervision.analytics.slice(index + 1),
          ];
        }
      }

      // Обновляем локальную копию активности
      this.activity = updatedActivity;

      // Также обновляем активность в списке supervisions
      this.supervisions.forEach((supervision) => {
        if (
          supervision.id === this.supervision?.id &&
          supervision.analytics &&
          Array.isArray(supervision.analytics)
        ) {
          const activityIndex = supervision.analytics.findIndex(
            (a) => a.id === updatedActivity.id
          );
          if (activityIndex !== -1) {
            supervision.analytics = [
              ...supervision.analytics.slice(0, activityIndex),
              updatedActivity,
              ...supervision.analytics.slice(activityIndex + 1),
            ];
          }
        }
      });
    },
    async deleteNotVerified() {
      // if (
      //   !confirm("Вы уверены, что хотите удалить неподтвержденные наблюдения?")
      // ) {
      //   return;
      // }
      this.$store.commit("setLoadersCount", "+");
      const params = {};
      if (this.params.organization)
        params.organization = this.params.organization;
      if (this.params.worker) params.worker = this.params.worker;
      if (this.params.user) params.user = this.params.user;
      if (this.params.search) params.search = this.params.search;

      const { value, error } = await Repository.Supervision.deleteNotVerified(
        params
      );
      this.$store.commit("setLoadersCount", "-");
      if (value) {
        await this.clearFilter();
      }
    },
  },
  computed: {
    ...mapState({
      iconsModals: (state) => state.modals.iconsModals,
    }),
    isFilterActive() {
      return (
        !!this.params.worker ||
        !!this.params.user ||
        !!this.params.search ||
        !!this.params.date ||
        this.params.organization !== "" ||
        this.params.verified !== false
      );
    },
    unverifiedCount() {
      return this.supervisions.filter((item) => !item.verified).length;
    },
  },
};
</script>

<style lang="scss" module>
.analytics {
  display: flex;
  overflow: hidden;
  height: 100vh;
  .tableContent {
    width: 100%;
    overflow: auto;
    @include scrollbarY;
    .container {
      display: flex;
      overflow: auto;
    }
  }
}
</style>